import React from 'react';
import Contact from '../components/Contact';
import SEO from '../components/SEO';

const ContactPage = () => {
  return (
    <div>
      <SEO 
        title="Contact Us | Get Expert Investment Advice | Rubicon Finservices"
        description="Get in touch with Rubicon Finservices for personalized investment advice. Located in Kolkata. Call +91 96740 44566 or email communications@rubiconfinservices.com. AMFI Registered ARN: 102867."
        keywords="contact rubicon finservices, mutual fund advisor Kolkata, investment consultation, financial planning contact, AMFI advisor contact, wealth management Kolkata"
        ogImage="https://customer-assets.emergentagent.com/job_rubicon-funds/artifacts/7akuxub4_LOGO.png"
      />
      <Contact />
    </div>
  );
};

export default ContactPage;
